import { Divider, Grid, Typography } from "@mui/material";
import DatasetCard from "./DatasetCard";
import { StorageIcon } from "../../icons";
import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

interface DatasetGridViewProps {
  datasetList: DatasetItem[];
}

export default function DatasetGridView({ datasetList }: DatasetGridViewProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 12px",
          marginBottom: "8px",
          borderRadius: "8px",
          background: "var(--dk-surface-2, #f9fafb)",
          border: "1px solid var(--dk-border, #e5e7eb)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "7px" }}>
          <div
            style={{
              width: 26,
              height: 26,
              borderRadius: "6px",
              background: "#fff7ed",
              border: "1px solid #fed7aa",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <StorageIcon sx={{ fontSize: 14, color: "#f97316" }} />
          </div>
          <span style={{ fontSize: "12px", fontWeight: 600, color: "var(--dk-text-2, #374151)" }}>프로젝트가 할당되지 않은 데이터셋</span>
          {datasetList.length > 0 && (
            <span
              style={{
                fontSize: "10px",
                fontWeight: 700,
                padding: "2px 7px",
                borderRadius: "20px",
                background: "#fff7ed",
                border: "1px solid #fed7aa",
                color: "#ea580c",
              }}
            >
              {datasetList.length}
            </span>
          )}
        </div>

        <button
          id="expand-collapse-dataset-btn"
          onClick={() => setIsExpanded(!isExpanded)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            padding: "4px 10px",
            borderRadius: "6px",
            border: "1px solid var(--dk-border, #e5e7eb)",
            background: "var(--dk-surface, #fff)",
            fontSize: "11px",
            fontWeight: 500,
            color: "var(--dk-text-2, #6b7280)",
            cursor: "pointer",
            transition: "all .15s",
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLElement).style.borderColor = "#d1d5db";
            (e.currentTarget as HTMLElement).style.color = "#374151";
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLElement).style.borderColor = "#e5e7eb";
            (e.currentTarget as HTMLElement).style.color = "#6b7280";
          }}
        >
          {isExpanded ? "접기" : "펼치기"}
          {isExpanded ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
        </button>
      </div>

      <AnimatePresence>
        {isExpanded && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
            style={{ overflow: "hidden", marginBottom: "16px" }}
          >
            <div
              id="dataset-card-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
                gap: "10px",
              }}
            >
              {datasetList.map((item) => (
                <DatasetCard item={item} key={item.id} />
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <div style={{ height: "1px", background: "var(--dk-surface-3, #e5e7eb)", marginBottom: "12px" }} />
    </>
  );
}
